export default "__VITE_ASSET__ea640500__"